import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts';
import { fetchCreditoDaNota } from '../api/CreditoIbsCbsApi';

export function useCreditoDaNota(chaveAcesso: string | undefined, enabled: boolean) {
  const { user } = useAuth();
  const cnpjGestor = user?.cnpj;

  return useQuery({
    queryKey: ['credito-ibs-cbs-nota', cnpjGestor, chaveAcesso],
    queryFn: () => fetchCreditoDaNota(chaveAcesso ?? ''),
    staleTime: 60 * 1000,
    enabled: enabled && !!cnpjGestor && !!chaveAcesso,
  });
}
